import { lazy, Suspense } from "react";
import { helperFace } from "../lib/helperPresentation";

// The helpers' bot avatars (MIT), loaded on first use. Same face per chat id as Build.
const BotAvatar = lazy(() => import("bot-avatars").then((m) => ({ default: m.BotAvatar })));

/** The chat's bot face. It hops while the agent works. `size` may be a CSS length
 *  (e.g. a variable the sidebar sets per pointer), the library draws at 64 px then. */
export default function ChatAvatar({ id, working, size = 36 }: { id: string; working: boolean; size?: number | string }) {
  const face = helperFace(undefined, id);
  return (
    <span className="sbAvatar" style={{ width: size, height: size }} aria-hidden="true">
      <Suspense fallback={<span className="sbAvatar__fallback" style={{ background: face.color ?? "var(--ju-surface-3)" }} />}>
        <BotAvatar type={face.type} color={face.color} size={size} state={working ? "working" : "default"}
          paused={!working} interactive={false} theme="dark" jumpEvery={0} />
      </Suspense>
    </span>
  );
}
